var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 3C10.4478 3 8 5.43222 8 8.4C8 11.3678 10.4478 13.8 13.5 13.8C16.5522 13.8 19 11.3678 19 8.4C19 5.43222 16.5522 3 13.5 3ZM6 8.4C6 4.29853 9.37254 1 13.5 1C17.6275 1 21 4.29853 21 8.4C21 12.5015 17.6275 15.8 13.5 15.8C9.37254 15.8 6 12.5015 6 8.4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 19C4.55228 19 3 20.5523 3 22.5C3 24.4477 4.55228 26 6.5 26H20.5C22.434 26 24.0107 24.4571 24.0999 22.4801C24.0894 20.5417 22.5411 19 20.6 19H6.5ZM1 22.5C1 19.4477 3.44772 17 6.5 17H20.6C23.6523 17 26.1 19.4477 26.1 22.5C26.1 22.5133 26.0997 22.5267 26.0992 22.54C25.9787 25.5533 23.5594 28 20.5 28H6.5C3.44772 28 1 25.5523 1 22.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.ea261a280f58cc29e0a8ad2fb8f2166b.svg";
export { ForwardRef as ReactComponent };